import React from 'react';
import { logo_home } from '../../../Data/Images/Home';
import Language from '../../../Layout/Header/Language';

// Minimal header for the lead gen pages: logo and language switch only, no nav, login or quiz CTA.
const BfHeader = () => (
  <header className="bflg-header">
    <span className="bflg-header__spacer" aria-hidden="true" />
    <img className="bflg-header__logo" src={logo_home} alt="riise" width="72" height="auto" />
    <ul className="bflg-header__lang">
      <Language darkText />
    </ul>
  </header>
);

export default BfHeader;
